import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/case-submissions";
import {Loading} from "components/helpers";
import Row from "./row";

export default function AdminCaseSubmissionsList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (id) => {
    setRecords(records.filter((record) => record.id !== id));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.records));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <h1 className="text-center">Submissions</h1>
          <div className="table-responsive rounded">
            <table className="table table-hover text-center">
              <thead className="thead-dark">
                <tr>
                  <th>Author</th>
                  <th>Title</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {records.map((record) => (
                  <Row key={record.id} onDestroy={onDestroy} record={record} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
